module.exports = CircleProgressBarView = Backbone.View.extend
  className: 'circular-progress-bar'

  initialize: ->
    @$status = @$ '.status'
    @$rightSlice = @$ '.right-half .slice'
    @$leftSlice = @$ '.left-half .slice'
    @$leftHalf = @$ '.left-half'

  updateProgress: (progress, text) ->
    return unless 0 <= progress <= 1
    firstHalfAngle = 180
    secondHalfAngle = 0

    drawAngle = progress * 360
    if drawAngle <= 180
      firstHalfAngle = drawAngle
    else
      @removeClips(@$leftHalf)
      @removeClips(@$rightSlice)
      secondHalfAngle = drawAngle - 180

    @rotate @$rightSlice, firstHalfAngle
    @rotate @$leftSlice, secondHalfAngle
    @$status.text text

  rotate: (element, degree) ->
    element?.css
      'transform': "rotate(#{degree}deg)"

  removeClips: (element) ->
    if element.css('clip') != 'auto'
      element.css 'clip', 'auto'



// WEBPACK FOOTER //
// ./modules/circular_progress_bar/frontend/views/circular_progress_bar.coffee